<a [routerLink]="routerLink">
  <div class="d-flex">
    <fa-icon [icon]="['far', 'chevron-left']" class="me-4"></fa-icon>
    <span>{{ label }}</span>
  </div>
</a>
